<!-- 修改邮箱组件 -->
<template id="modify_email">
  <section class="modify-email">
    <steps :title="stepTitle" :step="currentStep"></steps>
    <div class="" :is="modify_view" :v_type="vType" :switch_enabled="true" :btn_text="btnText" :request="request" :finish_title="finish_title" :modify_type="stepTitle" @switchValidate="switchValidate" @bind_email_success="bind_email_success" @next="next" @finish="finish" @errorResult="errorResult"></div>
  </section>
</template>

<script>
  import steps from './../steps.vue'
  import id_validate from './../id_validate.vue'
  import bind_email from './bind_email.vue'
  import finish from './../finish.vue'

  export default {
    props: ['modify_view', 'info', 'finish_title'],
    data() {
      return {
        btnText: '提交',
        stepTitle: '邮箱',
        currentStep: 1,
        vType: 'email',
        request: {
          email: this.info[0].value
        }
      }
    },
    methods: {
      /*
       ** 更换修改方式
       */
      switchValidate(type) {
        this.vType = type;

        if(type == 'phone'){
          this.request.phone = this.info[1].value;
          delete this.request.email;
        }
        else if(type == 'email'){
          this.request.email = this.info[0].value;
          delete this.request.phone;
        }
      },
      /*
       ** 下一步
       */
      next() {
        this.$emit('next');
        this.currentStep++;
      },
      /*
       ** 完成验证
       */
      finish() {
        this.$emit('finish');
        this.currentStep = 1;
      },
      /*
       ** 绑定邮箱成功
       */
      bind_email_success(data) {
        this.$emit('bind_email_success', data);
      },
      errorResult(response) {
        this.$emit('errorResult', response);
      }
    },
    components: {
      steps,
      id_validate,
      bind_email,
      finish
    }
  }
</script>

<style media="screen" lang="scss">
  .modify-email{
    width: 810px;
    .finish{
      padding-top: 0 !important;
    }
  }
</style>



// WEBPACK FOOTER //
// modify_email.vue?260a02c0